export const faqs = [
  {
    q: "見積もりだけでもお願いできますか？",
    a: "はい。お見積もりは無料ですので、まずはお気軽にご相談ください。",
  },
  {
    q: "少量の不用品でもお願いできますか？",
    a: "はい。少量からご相談可能です。まずは不用品の内容や量をお知らせください。",
  },
  {
    q: "不用品が大量にあるのですが対応できますか？",
    a: "はい。一軒家や空き家など、まとまった量の片付けについてもご相談いただけます。量が多い場合は、事前に現地を確認したうえでお見積もりします。",
  },
  {
    q: "重たい家具などは自分で外に出しておく必要がありますか？",
    a: "基本的にはそのままの状態でご相談いただいて大丈夫です。搬出方法についても現地確認時にご案内します。",
  },
  {
    q: "自分で仕分けをしておく必要はありますか？",
    a: "必ずしも事前にすべて仕分けしていただく必要はありません。必要な物・残しておきたい物がある場合は、事前にお知らせください。",
  },
  {
    q: "見積もり後に追加料金がかかることはありますか？",
    a: "お見積もり時に確認した作業内容から変更がなければ、原則として追加料金は発生しない料金体系を予定しています。追加の作業や回収をご希望の場合は、事前に金額をご説明し、ご了承いただいてから対応します。",
  },
  {
    q: "遺品整理もお願いできますか？",
    a: "はい。遺品の仕分け・搬出・片付けについてもご相談いただけます。ご遺族のお気持ちにも配慮しながら対応いたします。",
  },
  {
    q: "片付け後にリフォームもお願いできますか？",
    a: "はい。ここが弊社の大きな特徴です。株式会社小林建設はもともと住宅リフォームを行っている建設会社ですので、片付け後のクロス・床・原状回復から、屋根・外壁などの住宅リフォームまでまとめてご相談いただけます。",
  },
  {
    q: "どんな会社が運営していますか？",
    a: "埼玉県春日部市にある株式会社小林建設が運営しています。屋根工事・塗装工事を中心に住宅リフォームを行っている会社で、会社所在地・ホームページ・施工事例等もご確認いただけます。",
  },
  {
    q: "春日部市以外でもお願いできますか？",
    a: "春日部市を中心に、越谷市・さいたま市など近隣地域についても対応予定です。地域によって異なりますので、まずはお気軽にお問い合わせください。",
  },
];